import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../default-settings-service.service';

@Component({
  selector: 'app-exc-progbar',
  templateUrl: './app-exc-progbar.component.html',
  styles: []
})
export class AppExcProgbarComponent extends ExcTranslation implements OnInit {
  private sum: number;
  private _data: ExcProgbarData[] = [];
  private _colors = [
    {f: 'rgba(32, 83, 148, 1)', b: 'rgba(32, 83, 148, 0.6)'},
    {f: 'rgba(250, 169, 51, 1)', b: 'rgba(250, 169, 51, 0.6)'},
    {f: 'rgba(3, 181, 56, 1)', b: 'rgba(3, 181, 56, 0.6)'},
    {f: 'rgba(88, 200, 224, 1)', b: 'rgba(88, 200, 224, 0.6)'},
    {f: 'rgba(181, 3, 154, 1)', b: 'rgba(181, 3, 154, 0.6)'}
  ];
  @Input() Title: string;
  @Input() Format: string;
  @Input() ValueInTooltip: boolean;
  @Input()  set data(value: ExcProgbarData[]) {
    this._data = value;
    this.sum = 0;
    for (let i = 0; i < this._data.length; i++) {
      this.sum += this._data[i].Value;
      if (this._data[i].BackgroundColor === null) {
        this._data[i].BackgroundColor = this._colors[i % this._colors.length].b;
        if (this._data[i].TextColor === null) {
          this._data[i].TextColor = this._colors[i % this._colors.length].f;
        }
      }
    }
  }
  get data() {
    return this._data;
  }
  constructor(private excDss: DefaultSettingsService) {
    super();
    this.Format = this.Format || null;
    this.ValueInTooltip = this.ValueInTooltip || false;
  }
  getStyle(o) {
    let x = o.Value / this.sum * 100;
    x = Math.fround(x);
    if (o.BorderColor !== null) {
      return {width:  'calc(' + x + '% - 0.5rem)'
        , padding: (o.Value === 0 ? '0' : '0 0.25rem 0 0.25rem')
        , lineHeight: '1.5rem'
        , minHeight: '1.5rem'
        , float: 'left'
        , backgroundColor: o.BackgroundColor
        , visibility: o.Value === 0 ? 'hidden' : 'visible', cursor: 'default'};
    }
    return {width: x + '%'
            , visibility: o.Value === 0 ? 'hidden' : 'visible', cursor: 'default'};
  }
  getTextStyle(o) {
    return {color: (o.TextColor === null ? '#ffffff' : o.TextColor)
        };
  }
  getClass(o) {
    const cls = [];
   if (this.Format === 'currency') {
     cls.push('th-right');
   }
    cls.push('th-center');
   if (o.CssClass !== null && o.CssClass.length > 0) {
     for (const x of o.CssClass) {
       cls.push(x);
     }
   }
   return cls;
  }
  ngOnInit() {
  }
}
export class ExcProgbarData {
  Value: number ;
  Tooltip: string = null;
  CssClass: string[] = null;
  TextColor: string = null;
  BackgroundColor: string = null;
  constructor(Value, Tooltip?, BackgroundColor?, TextColor?, Format?, CssClass: string[] = null) {
    this.Value = Value;
    this.Tooltip = Tooltip;
    this.TextColor = TextColor || null;
    this.BackgroundColor = BackgroundColor || null;
    this.CssClass = CssClass || null;
  }
}
